import { QESButton } from "@app/shared/qes-standards";
import React, { FC, useContext, useRef } from "react";
import { JobBarChart } from "./JobBarChart";
import { JobStastiticsContext } from "./JobStatisticsContext";
import { resizeChartToFitLabels } from "./resizeChart";
import { GraphTypeEnum, PreDefinedJobStatisticsChart } from "./types";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface PredefinedJobBarChartWrapperProps {
    chartModel: PreDefinedJobStatisticsChart;
}


export const PredefinedJobBarChartWrapper: FC<React.PropsWithChildren<PredefinedJobBarChartWrapperProps>> = (props: PredefinedJobBarChartWrapperProps) => {
    const context = useContext(JobStastiticsContext);
    const containerRef = useRef<HTMLSpanElement>(null);

    return (
        <span ref={containerRef}>
            <QESButton
                className="job-chart__refresh"
                qesType="secondary"
                qesTestId={`job-chart__refresh--${props.chartModel.jobType}--${props.chartModel.chartType}`}
                onClick={() => context.refreshPredefinedChart(props.chartModel.jobType, props.chartModel.chartType)}
            >
                <QesIcon iconName={QesIcons.FontAwesome.Refresh} height="14" width="12" description="refresh chart" />
            </QESButton>
            <QESButton
                className="job-chart__resize"
                qesType="secondary"
                qesTestId={`job-chart__resize--${props.chartModel.jobType}--${props.chartModel.chartType}`}
                onClick={() => resizeChartToFitLabels(containerRef.current)}
            >
                <QesIcon iconName={QesIcons.FontAwesome.ArrowsVertical} height="14" width="6" description="resize chart" />
            </QESButton>
            <JobBarChart
                chartType={props.chartModel.chartType}
                dataPoints={props.chartModel.dataPoints}
                yAxisLabel={props.chartModel.chartType === GraphTypeEnum.Unknown ? "Job Count" : props.chartModel.chartType}
            />
        </span>
    )
}
